import BuyWithPrimeReviews from "@/snippets/products/BuyWithPrimeReviews"
import { useCountry } from "@backpackjs/storefront";
import { useEffect, useRef, useState } from "react"

export default function ReviewsWrapper({selectedVariant, product}) {
  const isBrowser = typeof(window) !== 'undefined';
  const amazonContainer = useRef(null);
  const { country } = useCountry();
  const countryCode = country?.isoCode || 'US';
  const isUs = countryCode === 'US';
  const [currentTab, setCurrentTab] = useState('Site Reviews')
  const [reviews, setReviews] = useState(['Site Reviews']);

  const buildTabs = () => {
    if(reviews.length > 1) {
      const tabs = reviews.map((tab) => {
        return (
          <button className={`button button--small !min-w-0 ${currentTab == tab ? 'button--primary' : ''}`} onClick={() => setCurrentTab(tab)}>{tab}</button>
        )
      })

      return tabs;
    }
  }

  useEffect(() => {
    if(isBrowser) {
      const mutationObserver = new MutationObserver((mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes') {
            const iframe = amazonContainer.current.querySelector('iframe')
            const iframeHidden = iframe ? iframe?.style['visibility'] === 'hidden' : true;

            if ((iframe && iframeHidden) || !isUs) {
              setReviews((prevReviews) => {
                return prevReviews.filter((tab) => tab !== 'Amazon Reviews');
              })
            }

            if (isUs && iframe && !iframeHidden) {
              setReviews((prevReviews) => {
                if(prevReviews.some((review) => review == 'Amazon Reviews')) { return prevReviews; }
                return [...prevReviews, 'Amazon Reviews'];
              });
            }
          }
        }
      })

      mutationObserver.observe(amazonContainer.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      })
    }

    return () => {
      if(isBrowser) {
        mutationObserver.disconnect();
      }
    }
  }, [])

  return (
    <section className="reviews-wrapper">
      <div className="tabs-container flex gap-5 justify-center px-5">
        {buildTabs()}
      </div>
      <div className="reviews-container">
        <div className={`yotpo-reviews ${(currentTab !== 'Site Reviews') ? 'hidden' : ''}`}>
          <div
            key={product?.legacyResourceId}
            id="pdp-yotpo-reviews-widget"
            className="yotpo yotpo-main-widget !mb-[44px] md:!mb-[80px]"
            data-product-id={product?.legacyResourceId}
            data-price={`$${selectedVariant?.price}`}
            data-currency="USD"
            data-name={product?.title}
            data-url={product?.url}
            data-image-url={product?.images[0]?.src}
          />
        </div>
        <div ref={amazonContainer} className={`amazon-reviews ${(currentTab !== 'Amazon Reviews') ? 'hidden' : ''}`}>
          <BuyWithPrimeReviews
            key={`${selectedVariant?.sku}-reviews`}
            sku={selectedVariant?.sku} />
        </div>
      </div>
    </section>
  )
}